<template>
  <div class="font-sans">
    <ModalProvider>
      <Nuxt />
    </ModalProvider>
  </div>
</template>
<script>
import { useAsync } from '@nuxtjs/composition-api';
import { ModalProvider } from '~/modules/common/components/ui/OModal/ModalProvider';
import { installAuthContext, useAuth } from '~/modules/auth/state/useAuth';
import { installMetadataConfig } from '~/modules/config/configUtils';
export default {
  components: {
    ModalProvider,
  },
  setup() {
    installMetadataConfig();
    installAuthContext();
    const { initAuth } = useAuth();

    // Login user at every page or generate oio token for login register operations
    useAsync(async () => {
      if (process.server) {
        await initAuth();
      }
    });
  },
};
</script>
